import Pagination from "../../../../material/pagination/Pagination";
import PaginationConfig from "../../../../material/pagination/PaginationConfig";
import route from "../../../../enum/route";
import Operator from "../../../../material/pagination/Operator";
import PaginationColumn from "../../../../material/pagination/PaginationColumn";
import {useNavigate} from "react-router";
import Type from "../../../../material/pagination/Type";
import Order from "../../../../entity/b2csdu/Order";
import useSecurity from "../../../../use/useSecurity";
import {Alert, Button} from "@mui/material";
import Box from "@mui/material/Box";
import database from "../../../../database/database";

export default function ({companyId}) {
    const security = useSecurity();
    const navigate = useNavigate();

    const handleAuthClick = () => {
        database.write(database.TABLE_ROUTING, "after_auth", null);
        window.location.replace(process.env.REACT_APP_AWS_AUTH_PAGE.replace("{clientId}", process.env.REACT_APP_AWS_CLIENT_ID).replace("{redirectUri}", process.env.REACT_APP_AWS_REDIRECT_URI));
    }

    if (!security.roles.includes("ROLE_FAIRFAIR_B2CSDU_ARTISAN")) {
        // Deprecated
        return (
            <>
                <Alert severity="warning">
                    Vous devez vous déconnecter et vous reconnecter pour avoir accès aux missions RI
                </Alert>
                <Box mt={5} display="flex" justifyContent="center">
                    <Button onClick={handleAuthClick} variant="contained">
                        Je me reconnecte
                    </Button>
                </Box>
            </>
        )
    }

    return (
        <Pagination
            paginationConfig={
                new PaginationConfig()
                    .setId("intervention-list-b2csdu")
                    .setUri("/service-data-repository/entrepreneur/pagination/b2csdu/order")
                    .setOnRowClicked(row => navigate(route.ARTISAN_B2CSDU_INTERVENTION.replace(":token", row.intervention_token)))
                    .setFieldAsId("order_id")
                    .addFixedFilter("company_id", Operator.EQUALS, companyId)
                    .addFixedFilter("order_status", Operator.EQUALS, Order.STATUS_IN_PROGRESS)
                    .setHideToolbar(true)
                    .setPerPage(5)
                    .addPaginationColumn(
                        new PaginationColumn()
                            .setHeader("Dossier")
                            .setField("order_id")
                            .setType(Type.NUMBER)
                            .setDisableSearchOption(true)
                            .setDefaultWidth(0.1)
                    )
                    .addPaginationColumn(
                        new PaginationColumn()
                            .setHeader("Ville")
                            .setField("address_city")
                            .setDisableSearchOption(true)
                            .setDefaultWidth(0.1)
                    )
            }
        />
    )
}